<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2021-12-09 21:15:12
 * @LastEditTime: 2022-01-09 14:23:49
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
};
</script>

<style lang="less">
#app {
  min-width: 1080px;
  overflow-x: scroll;
}
</style>
